import { render, staticRenderFns } from "./CompensatoryRequestDocs.vue?vue&type=template&id=5c5d4425&scoped=true"
import script from "./CompensatoryRequestDocs.vue?vue&type=script&lang=js"
export * from "./CompensatoryRequestDocs.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryRequestDocs.vue?vue&type=style&index=0&id=5c5d4425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d4425",
  null
  
)

export default component.exports